import { render, staticRenderFns } from "./RoomChats.vue?vue&type=template&id=22c378f8&"
import script from "../js/RoomChats.vue?vue&type=script&lang=js&"
export * from "../js/RoomChats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports